(function () {
  function initTabs(root) {
    root.querySelectorAll('[data-ctr-sub-tabs]').forEach(function (tabs) {
      if (tabs.dataset.ctrSubReady === 'true') {
        return;
      }
      tabs.dataset.ctrSubReady = 'true';

      var buttons = tabs.querySelectorAll('[data-ctr-sub-tab]');
      var panels = tabs.querySelectorAll('[data-ctr-sub-panel]');

      buttons.forEach(function (button, index) {
        button.addEventListener('click', function () {
          buttons.forEach(function (item, itemIndex) {
            var active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
            if (panels[itemIndex]) {
              panels[itemIndex].classList.toggle('is-active', active);
              panels[itemIndex].hidden = !active;
            }
          });
        });
      });
    });
  }

  function initCarousel(root) {
    root.querySelectorAll('[data-ctr-sub-carousel]').forEach(function (carousel) {
      if (carousel.dataset.ctrSubReady === 'true') {
        return;
      }
      carousel.dataset.ctrSubReady = 'true';

      var viewport = carousel.querySelector('[data-ctr-sub-viewport]');
      var track = carousel.querySelector('.ctr-sub-lp-products__track');
      var dots = carousel.querySelector('[data-ctr-sub-dots]');
      var prev = carousel.querySelector('[data-ctr-sub-prev]');
      var next = carousel.querySelector('[data-ctr-sub-next]');
      if (!viewport || !track) {
        return;
      }

      function pageCount() {
        var max = track.scrollWidth - viewport.clientWidth;
        if (max <= 4) {
          return 1;
        }
        var card = track.querySelector('.ctr-sub-lp-products__card');
        var width = card ? card.getBoundingClientRect().width + 24 : viewport.clientWidth;
        return Math.max(1, Math.ceil(max / width) + 1);
      }

      function renderDots() {
        if (!dots) {
          return;
        }
        var count = pageCount();
        dots.innerHTML = '';
        for (var i = 0; i < count; i += 1) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ctr-sub-lp-products__dot';
          dot.setAttribute('aria-label', 'Show product group ' + (i + 1));
          dot.addEventListener('click', function (event) {
            var index = Array.prototype.indexOf.call(dots.children, event.currentTarget);
            var card = track.querySelector('.ctr-sub-lp-products__card');
            var width = card ? card.getBoundingClientRect().width + 24 : viewport.clientWidth;
            viewport.scrollTo({ left: index * width, behavior: 'smooth' });
          });
          dots.appendChild(dot);
        }
        update();
      }

      function update() {
        var max = track.scrollWidth - viewport.clientWidth;
        var card = track.querySelector('.ctr-sub-lp-products__card');
        var width = card ? card.getBoundingClientRect().width + 24 : viewport.clientWidth;
        var index = width ? Math.round(viewport.scrollLeft / width) : 0;
        if (prev) {
          prev.disabled = viewport.scrollLeft <= 2;
        }
        if (next) {
          next.disabled = viewport.scrollLeft >= max - 2;
        }
        if (!dots) {
          return;
        }
        Array.prototype.forEach.call(dots.children, function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      }

      function scrollByCard(direction) {
        var card = track.querySelector('.ctr-sub-lp-products__card');
        var width = card ? card.getBoundingClientRect().width + 24 : viewport.clientWidth * 0.8;
        viewport.scrollBy({ left: width * direction, behavior: 'smooth' });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          scrollByCard(-1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          scrollByCard(1);
        });
      }
      viewport.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', function () {
        renderDots();
      });
      renderDots();
    });
  }

  function initHotspots(root) {
    root.querySelectorAll('[data-ctr-sub-hotspots]').forEach(function (group) {
      if (group.dataset.ctrSubReady === 'true') {
        return;
      }
      group.dataset.ctrSubReady = 'true';

      group.querySelectorAll('[data-ctr-sub-hotspot-toggle]').forEach(function (button) {
        button.addEventListener('click', function () {
          var hotspot = button.parentElement;
          var card = hotspot.querySelector('[data-ctr-sub-hotspot-card]');
          var willOpen = button.getAttribute('aria-expanded') !== 'true';

          group.querySelectorAll('[data-ctr-sub-hotspot-toggle]').forEach(function (other) {
            other.setAttribute('aria-expanded', 'false');
            var otherCard = other.parentElement.querySelector('[data-ctr-sub-hotspot-card]');
            if (otherCard) {
              otherCard.hidden = true;
            }
          });

          if (willOpen && card) {
            button.setAttribute('aria-expanded', 'true');
            card.hidden = false;
          }
        });
      });
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    initTabs(scope);
    initCarousel(scope);
    initHotspots(scope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
